import React from "react";

import Slider from "react-slick";

const AgentForceLists = [
    {
      id: 1,
        title: "Role",
        description:
            "팀내에서 추구하는\n" +
            "에이전트의 목표",
        imgSrc: "/img/salesforce/agent-icon-01.svg"
    },
    {
        id: 2,
        title: "Trust Data",
        description:
            "에이전트가 역할을\n" +
            "수행하는 데 필요한 정보",
        imgSrc: "/img/salesforce/agent-icon-02.svg"
    },
    {
        id: 3,
        title: "Actions",
        description:
            "에이전트가\n" +
            "수행해야하는 목표",
        imgSrc: "/img/salesforce/agent-icon-03.svg"
    },
    {
        id: 4,
        title: "Guardrails",
        description:
            "에이전트 업무 수행을\n" +
            "위한 가이드라인",
        imgSrc: "/img/salesforce/agent-icon-04.svg"
    },
    {
        id: 5,
        title: "Channels",
        description:
            "웹, 모바일,\n" +
            "What sApp, Slack",
        imgSrc: "/img/salesforce/agent-icon-05.svg"
    }
];

const slideLists = [
    {
        id: 1,
        // arrowLeft: "/img/salesforce/arrowLeft.png",
        imgSrc01: "/img/salesforce/agent-user-img-01.png",
        question: "에이전트의 Role이란 무엇인가요?",
        answer: "Role은 에이전트의 목표를 의미합니다. 이는 에이전트가 수행해야 할 작업과 팀 내에서 달성해야 할 목표를 의미합니다. 에이전트는 이 Role을 기반으로 특정 임무를 수행하며, 팀의 목표와 조화를 이루는 방식으로 기여합니다.",
        imgSrc02: "/img/salesforce/agent-bots-img.png",
        // arrowRight: "/img/salesforce/arrowRight.png",
    },
    {
        id: 2,
        imgSrc01: "/img/salesforce/agent-user-img-02.png",
        question: "에이전트의 Trusted Data란 무엇인가요?",
        answer: "Trusted Data란 에이전트가 작업을 수행하는 데 필요한 정보입니다. 여기에는 사내 문서, CRM 데이터, Data Cloud로 수집한 외부 데이터, 공공 웹사이트 정보 등이 포함될 수 있습니다.",
        imgSrc02: "/img/salesforce/agent-bots-img.png"
    },
    {
        id: 3,
        imgSrc01: "/img/salesforce/agent-user-img-03.png",
        question: "에이전트의 Actions란 무엇인가요?",
        answer: "Actions는 에이전트가 작업을 수행할 수 있도록 사전에 정의된 작업들로, 특정 트리거나 지시에 따라 실행됩니다. 예를 들어, 플로우 실행, 템플릿 요청, 또는 Apex 코드를 실행하는 것이 포함될 수 있습니다.",
        imgSrc02: "/img/salesforce/agent-bots-img.png"
    },
    {
        id: 4,
        imgSrc01: "/img/salesforce/agent-user-img-04.png",
        question: "에이전트의 Guardrails이란 무엇인가요?",
        answer: "Guardrails은 에이전트가 할 수 있는 것과 할 수 없는 것을 정의합니다. 이는 작업자에게 문제를 이관하라는 자연어 지시일 수도 있고, Einstein Trust Layer의 내장된 보안 기능을 따른 제한일 수도 있습니다.",
        imgSrc02: "/img/salesforce/agent-bots-img.png"
    },
    {
        id: 5,
        imgSrc01: "/img/salesforce/agent-user-img-05.png",
        question: "에이전트의 Channels이란 무엇인가요?",
        answer: "Channels이란 에이전트가 작업을 수행할 수 있는 애플리케이션을 의미합니다. 여기에는 웹사이트, CRM, 모바일 앱, Slack 등 다양한 플랫폼이 포함됩니다.",
        imgSrc02: "/img/salesforce/agent-bots-img.png"
    },
];

interface SlickProps {
  className? : string;
  style? : React.CSSProperties;
  onClick?: () => void;
}
function NextArrow({ className, style, onClick }: SlickProps) {
  return (
    <div
      className={`${className} custom-arrow`}
      style={{ ...style, display: "block", width: "40px", height: "40px" }}
      onClick={onClick}
    >
    </div>
  );
}

function PrevArrow({ className, style, onClick }: SlickProps) {
  return (
    <div
      className={`${className} custom-arrow`}
      style={{ ...style, display: "block", width: "40px", height: "40px" }}
      onClick={onClick}
    >
    </div>
  );
}

export default class Slick extends React.Component {
  render() {
    const settings = {
        customPaging: function (index: number) {
            return (
                <a>
                    <div className="slider-box flex flex-col items-center justify-start gap-4 rounded-[15px] bg-[#F1E3D3]
                    sm:px-6 sm:py-6 px-4 py-4 sm:gap-8 lg:!justify-center lg:gap-4">
                        <img
                            className="sm:h-[54px] sm:w-[54px] h-[50px] w-[50px] rounded-full bg-[#E4C39D] object-contain"
                            src={AgentForceLists[index].imgSrc}
                            alt=""
                        />
                        <div className="Tab-box flex flex-col items-start md:items-start lg:!items-center">
                            <h2 className="whitespace-nowrap text-h3 font-semibold capitalize text-gray-800 dark:text-white">
                                {AgentForceLists[index].title}
                            </h2>
                            <p className="mt-0 text-left text-caption sm:mt-2 sm:text-center md:text-base">
                                {AgentForceLists[index].description}
                            </p>
                        </div>
                    </div>
                </a>
            );
        },
        dots: true,
        dotsClass: "slick-dots slick-thumb",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    nextArrow: undefined,
                    prevArrow: undefined,
                }
            }
        ]
    };
    return (
        <div>
            <Slider {...settings} className="agf_slide_wrap">
                {slideLists.map(list => (
                    <div
                        key={list.imgSrc01}
                        className="flex flex-row items-center md:pb-[150px] md:pl-[30px] md:pr-[30px] md:pt-[20px] pb-[150px] pl-[15px] pr-[15px] pt-[0px]"
                    >
                        <div className="mb-[25px] flex flex-row items-center">
                            <img
                                className="md:h-[120px] md:w-[120px] w-[80px] object-contain"
                                src={list.imgSrc01}
                                alt=""
                            />
                            <p className="ml-2 h-full rounded-[35px] rounded-bl-[8px] bg-white p-6 drop-shadow-xl">
                                {list.question}
                            </p>
                        </div>

                        <div className="relative float-right sm:w-[80%] md:w-[60%] w-[100%]">
                            <p className="sm:mr-[50px] mr-[0px] h-full rounded-[35px] rounded-br-[8px] bg-white p-6 drop-shadow-xl">
                                {list.answer}
                            </p>
                            <img
                                className="absolute right-0 md:right-0 md:top-28 bottom-[-130px] m-auto w-[150px] md:w-[190px] rounded-lg object-contain"
                                src={list.imgSrc02}
                                alt=""
                            />
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
  }
}
// export default Slick;
